var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogoSkubiq(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 188,
    height: 56,
    viewBox: "0 0 188 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M46.07,154.676H66.983v21.7H46.07Zm0,0",
    transform: "translate(-46.07 -154.676)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M46.07,196H72.646v20.769H46.07Zm0,0",
    transform: "translate(-46.07 -196)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M76,154.676h26.049v20.57H76Zm0,0",
    transform: "translate(-76 -154.676)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M85,195h21.276v21.336H85Zm0,0",
    transform: "translate(-85 -195)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo_skubiq",
    transform: "translate(-547 213)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_48",
    "data-name": "Rectangle 48",
    width: 188,
    height: 56,
    rx: 28,
    transform: "translate(547 -213)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "logo_skubiq-2",
    "data-name": "logo_skubiq",
    transform: "translate(520.43 -361.761)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(46.07 154.676)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M59.624,168.392a6.347,6.347,0,0,0,1.115-1.462l5.968-11.14c.248-.456.3-.757.148-.9s-.436-.1-.894.151l-10.848,6.127a6.768,6.768,0,0,0-1.414,1.142,6.432,6.432,0,0,0-1.117,1.464L46.6,174.882c-.259.458-.312.763-.164.916s.436.086.891-.168l10.879-6.1a6.754,6.754,0,0,0,1.414-1.142Zm0,0",
    transform: "translate(-46.194 -154.732)",
    fill: "#9823c6",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M99.058,176.3a2.483,2.483,0,0,0-.67-1.447L87.69,163.9a1.3,1.3,0,0,0-2.219.321l-5.981,11.116a2.481,2.481,0,0,0-.239,1.584,2.536,2.536,0,0,0,.655,1.449l10.7,10.939a1.3,1.3,0,0,0,1.19.458,1.365,1.365,0,0,0,1.026-.779l5.984-11.107a2.573,2.573,0,0,0,.252-1.586Zm0,0",
    transform: "translate(-14.375 -3.791)",
    fill: "#ffc34e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(46.07 178.078)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M72.407,209.506a1.366,1.366,0,0,0-.447-1.219L61.269,197.33a2.427,2.427,0,0,0-1.414-.67,2.331,2.331,0,0,0-1.546.243l-10.864,6.128a1.382,1.382,0,0,0-.312,2.269l10.7,10.954a2.384,2.384,0,0,0,1.414.688,2.413,2.413,0,0,0,1.546-.259l10.848-6.126a1.4,1.4,0,0,0,.759-1.053Zm0,0",
    transform: "translate(-46.331 -196.271)",
    fill: "#ff3e3c",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(63.019 154.676)",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M102.088,167.688a1.458,1.458,0,0,0-.445-1.235l-10.7-10.939a2.287,2.287,0,0,0-1.4-.686,2.389,2.389,0,0,0-1.548.257L77.133,161.2a1.387,1.387,0,0,0-.772,1.05,1.439,1.439,0,0,0,.46,1.235l10.7,10.954a2.38,2.38,0,0,0,1.414.687,2.356,2.356,0,0,0,1.533-.259l10.848-6.127A1.388,1.388,0,0,0,102.088,167.688Zm0,0",
    transform: "translate(-76.151 -154.729)",
    fill: "#26c4ff",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4",
    transform: "translate(68.116 177.511)",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M106.319,195.33c-.139-.151-.436-.1-.891.152l-10.864,6.1a7.488,7.488,0,0,0-2.544,2.6l-5.953,11.14q-.372.684-.164.914c.148.152.447.1.892-.168l10.848-6.126a6.972,6.972,0,0,0,1.429-1.141,7.466,7.466,0,0,0,1.117-1.462l5.981-11.11c.248-.455.3-.757.148-.9Zm0,0",
    transform: "translate(-85.359 -195.106)",
    fill: "#fe0fa6",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M73.915,191.807a2.542,2.542,0,0,0,.252-1.584,2.468,2.468,0,0,0-.668-1.449L62.8,177.82a1.317,1.317,0,0,0-1.19-.458,1.373,1.373,0,0,0-1.029.779L54.6,189.263a2.487,2.487,0,0,0-.237,1.584,2.528,2.528,0,0,0,.655,1.449l10.7,10.939a1.338,1.338,0,0,0,1.19.473,1.365,1.365,0,0,0,1.029-.794Zm0,0",
    transform: "translate(-3.581 -9.832)",
    fill: "#98d843",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    "data-name": "Group 7",
    transform: "translate(97.904 161.668)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M11.061-24.547A7.962,7.962,0,0,0,7.469-25.6a2.953,2.953,0,0,0-1.84.522,1.681,1.681,0,0,0-.672,1.416,1.751,1.751,0,0,0,.849,1.478,10.976,10.976,0,0,0,2.371,1.168,9.383,9.383,0,0,1,1.991.938,4.285,4.285,0,0,1,1.372,1.433,4.4,4.4,0,0,1,.54,2.283,4.187,4.187,0,0,1-.628,2.256A4.451,4.451,0,0,1,9.637-12.5a6.037,6.037,0,0,1-2.787.6,9.348,9.348,0,0,1-2.8-.434,8.677,8.677,0,0,1-2.451-1.221L2.717-15.5a7.185,7.185,0,0,0,1.876,1,5.9,5.9,0,0,0,2.017.4,3.621,3.621,0,0,0,2-.549,1.867,1.867,0,0,0,.858-1.69,1.883,1.883,0,0,0-.726-1.5,7.145,7.145,0,0,0-2.009-1.1,16.7,16.7,0,0,1-2.212-.982A4.635,4.635,0,0,1,3-21.282a3.642,3.642,0,0,1-.628-2.185,3.968,3.968,0,0,1,1.3-3.088,5.233,5.233,0,0,1,3.433-1.256,9.451,9.451,0,0,1,2.716.354,8.754,8.754,0,0,1,2.186,1Zm0,0",
    transform: "translate(-1.594 27.813)",
    fill: "#1c2120"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10",
    "data-name": "Group 10",
    transform: "translate(114.966 161.748)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9",
    "data-name": "Group 9",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8",
    "data-name": "Group 8",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M6.274-20.868l.345-.5,5.893-6.309h3.23L9.265-20.823,15.981-12H12.8L7.434-19.231l-1.1,1.071V-12H3.8v-15.67H6.336v6.008Zm0,0",
    transform: "translate(-3.797 27.672)",
    fill: "#1c2120"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13",
    "data-name": "Group 13",
    transform: "translate(132.843 161.748)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12",
    "data-name": "Group 12",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    "data-name": "Group 11",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M5.879-17.638a3.184,3.184,0,0,0,.469,1.681A3.6,3.6,0,0,0,7.64-14.718a3.556,3.556,0,0,0,1.787.46,3.746,3.746,0,0,0,1.832-.451,3.447,3.447,0,0,0,1.3-1.23,3.18,3.18,0,0,0,.478-1.7V-27.672h2.478v10.1a5.559,5.559,0,0,1-.805,2.982,5.6,5.6,0,0,1-2.2,2.035,6.583,6.583,0,0,1-3.079.726,6.515,6.515,0,0,1-3.07-.726,5.54,5.54,0,0,1-2.186-2.035,5.593,5.593,0,0,1-.8-2.982v-10.1h2.5Zm0,0",
    transform: "translate(-3.375 27.672)",
    fill: "#1c2120"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16",
    "data-name": "Group 16",
    transform: "translate(152.317 161.748)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15",
    "data-name": "Group 15",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14",
    "data-name": "Group 14",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M11.221-20.177a4.879,4.879,0,0,1,2.053,1.487,3.455,3.455,0,0,1,.743,2.194,3.893,3.893,0,0,1-1.54,3.389A6.307,6.307,0,0,1,8.681-12H3.8v-15.67H8.079a6.266,6.266,0,0,1,3.8,1.009,3.419,3.419,0,0,1,1.363,2.938,4.062,4.062,0,0,1-.531,2.115A3.843,3.843,0,0,1,11.221-20.177ZM6.319-21H8.486a2.062,2.062,0,0,0,1.628-.619,2.308,2.308,0,0,0,.549-1.575,1.84,1.84,0,0,0-.655-1.54,2.86,2.86,0,0,0-1.823-.522H6.319Zm2.256,6.672a3.566,3.566,0,0,0,2.07-.549,1.82,1.82,0,0,0,.8-1.6,1.71,1.71,0,0,0-.876-1.61,4.312,4.312,0,0,0-2.159-.5H6.319v4.256Zm0,0",
    transform: "translate(-3.797 27.672)",
    fill: "#1c2120"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_19",
    "data-name": "Group 19",
    transform: "translate(169.163 161.748)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_18",
    "data-name": "Group 18",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17",
    "data-name": "Group 17",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M6.319-27.672V-12H3.8v-15.67Zm0,0",
    transform: "translate(-3.797 27.672)",
    fill: "#1c2120"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_22",
    "data-name": "Group 22",
    transform: "translate(178.312 161.58)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21",
    "data-name": "Group 21",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20",
    "data-name": "Group 20",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M18.852-12.13h-7.1a8.875,8.875,0,0,1-1.663.168,7.874,7.874,0,0,1-4.008-1.062,7.93,7.93,0,0,1-2.92-2.893,7.823,7.823,0,0,1-1.071-4.026,7.794,7.794,0,0,1,1.071-3.991,8.2,8.2,0,0,1,2.92-2.938,7.693,7.693,0,0,1,4.008-1.1,7.691,7.691,0,0,1,4,1.1,8.349,8.349,0,0,1,2.938,2.947,7.691,7.691,0,0,1,1.1,3.982,7.748,7.748,0,0,1-.549,2.9,8.258,8.258,0,0,1-1.54,2.46h2.814ZM4.677-19.943A5.551,5.551,0,0,0,5.4-17.156,5.452,5.452,0,0,0,7.394-15.13a5.364,5.364,0,0,0,2.77.743,5.106,5.106,0,0,0,2.708-.743,5.4,5.4,0,0,0,1.947-2.026,5.574,5.574,0,0,0,.726-2.787,5.432,5.432,0,0,0-.734-2.77,5.6,5.6,0,0,0-1.982-2.026,5.211,5.211,0,0,0-2.734-.752,5.191,5.191,0,0,0-2.743.752,5.544,5.544,0,0,0-1.955,2.026A5.529,5.529,0,0,0,4.677-19.943Zm0,0",
    transform: "translate(-2.094 27.969)",
    fill: "#1c2120"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25",
    "data-name": "Group 25",
    transform: "translate(100.283 182.631)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_24",
    "data-name": "Group 24",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23",
    "data-name": "Group 23",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M3.047-11.511v5.344h-1.2v-5.344ZM2.038-13.546a.612.612,0,0,1,.221-.478.744.744,0,0,1,.5-.195.718.718,0,0,1,.5.195.625.625,0,0,1,.212.478.619.619,0,0,1-.212.478.708.708,0,0,1-.5.195.733.733,0,0,1-.5-.195A.606.606,0,0,1,2.038-13.546Zm0,0",
    transform: "translate(-1.844 14.219)",
    fill: "#1c2120"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_28",
    "data-name": "Group 28",
    transform: "translate(103.116 182.985)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27",
    "data-name": "Group 27",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26",
    "data-name": "Group 26",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M3.226-13.594v2.363h1.46v.956H3.226V-5.9H2.013v-4.38H1.031v-.956h.982v-2.363Zm0,0",
    transform: "translate(-1.031 13.594)",
    fill: "#1c2120"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_31",
    "data-name": "Group 31",
    transform: "translate(107.766 185.118)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_30",
    "data-name": "Group 30",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_29",
    "data-name": "Group 29",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M4-5.165a2.165,2.165,0,0,0,1.3-.469l.557.894a3.767,3.767,0,0,1-.929.451,3.132,3.132,0,0,1-.956.159A3.178,3.178,0,0,1,2.412-4.5,2.61,2.61,0,0,1,1.385-5.519a2.972,2.972,0,0,1-.354-1.46,2.714,2.714,0,0,1,.389-1.433A2.889,2.889,0,0,1,2.5-9.448,3.077,3.077,0,0,1,4-9.828a2.559,2.559,0,0,1,1.743.611A3.134,3.134,0,0,1,6.712-7.5L2.474-6.023a1.736,1.736,0,0,0,.628.637A1.819,1.819,0,0,0,4-5.165Zm-.1-3.707a1.572,1.572,0,0,0-1.212.522,1.847,1.847,0,0,0-.478,1.31c0,.131,0,.23.009.3L5.34-7.89A1.764,1.764,0,0,0,4.792-8.6,1.412,1.412,0,0,0,3.907-8.873Zm0,0",
    transform: "translate(-1.031 9.828)",
    fill: "#1c2120"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_34",
    "data-name": "Group 34",
    transform: "translate(114.943 185.118)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_33",
    "data-name": "Group 33",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32",
    "data-name": "Group 32",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M8.71-9.828a1.7,1.7,0,0,1,1.23.442,1.612,1.612,0,0,1,.487,1.159v3.964h-1.2v-3.53c-.024-.624-.307-.956-.849-.991a1.353,1.353,0,0,0-.841.283,1.9,1.9,0,0,0-.575.726,2.378,2.378,0,0,0-.212.964v2.548H5.525v-3.53c-.024-.624-.316-.956-.876-.991a1.331,1.331,0,0,0-.823.283,1.9,1.9,0,0,0-.575.734,2.319,2.319,0,0,0-.2.973v2.531h-1.2V-9.607H2.932l.088,1A2.275,2.275,0,0,1,3.861-9.5a2.334,2.334,0,0,1,1.23-.327,1.864,1.864,0,0,1,1.079.3,1.379,1.379,0,0,1,.575.832A2.481,2.481,0,0,1,7.6-9.527,2.173,2.173,0,0,1,8.71-9.828Zm0,0",
    transform: "translate(-1.844 9.828)",
    fill: "#1c2120"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_37",
    "data-name": "Group 37",
    transform: "translate(129.682 182.631)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_36",
    "data-name": "Group 36",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35",
    "data-name": "Group 35",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M3.047-11.511v5.344h-1.2v-5.344ZM2.038-13.546a.612.612,0,0,1,.221-.478.744.744,0,0,1,.5-.195.718.718,0,0,1,.5.195.625.625,0,0,1,.212.478.619.619,0,0,1-.212.478.708.708,0,0,1-.5.195.733.733,0,0,1-.5-.195A.606.606,0,0,1,2.038-13.546Zm0,0",
    transform: "translate(-1.844 14.219)",
    fill: "#1c2120"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_40",
    "data-name": "Group 40",
    transform: "translate(132.976 185.127)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39",
    "data-name": "Group 39",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_38",
    "data-name": "Group 38",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M5.162-9.812A1.754,1.754,0,0,1,6.4-9.361a1.536,1.536,0,0,1,.513,1.15v3.955H5.693V-7.8A1.083,1.083,0,0,0,5.418-8.5a.968.968,0,0,0-.734-.274,1.467,1.467,0,0,0-1.177.566,2.227,2.227,0,0,0-.46,1.451v2.5h-1.2V-9.6H2.932l.08,1.026a2.089,2.089,0,0,1,.849-.9A2.5,2.5,0,0,1,5.162-9.812Zm0,0",
    transform: "translate(-1.844 9.813)",
    fill: "#1c2120"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_43",
    "data-name": "Group 43",
    transform: "translate(139.659 182.985)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_42",
    "data-name": "Group 42",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41",
    "data-name": "Group 41",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M3.226-13.594v2.363h1.46v.956H3.226V-5.9H2.013v-4.38H1.031v-.956h.982v-2.363Zm0,0",
    transform: "translate(-1.031 13.594)",
    fill: "#1c2120"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_46",
    "data-name": "Group 46",
    transform: "translate(144.309 185.118)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_45",
    "data-name": "Group 45",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_44",
    "data-name": "Group 44",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M4-5.165a2.165,2.165,0,0,0,1.3-.469l.557.894a3.767,3.767,0,0,1-.929.451,3.132,3.132,0,0,1-.956.159A3.178,3.178,0,0,1,2.412-4.5,2.61,2.61,0,0,1,1.385-5.519a2.972,2.972,0,0,1-.354-1.46,2.714,2.714,0,0,1,.389-1.433A2.889,2.889,0,0,1,2.5-9.448,3.077,3.077,0,0,1,4-9.828a2.559,2.559,0,0,1,1.743.611A3.134,3.134,0,0,1,6.712-7.5L2.474-6.023a1.736,1.736,0,0,0,.628.637A1.819,1.819,0,0,0,4-5.165Zm-.1-3.707a1.572,1.572,0,0,0-1.212.522,1.847,1.847,0,0,0-.478,1.31c0,.131,0,.23.009.3L5.34-7.89A1.764,1.764,0,0,0,4.792-8.6,1.412,1.412,0,0,0,3.907-8.873Zm0,0",
    transform: "translate(-1.031 9.828)",
    fill: "#1c2120"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_49",
    "data-name": "Group 49",
    transform: "translate(151.486 180.667)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48",
    "data-name": "Group 48"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_47",
    "data-name": "Group 47",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M3.047-17.687V-7.671h-1.2V-17.687Zm0,0",
    transform: "translate(-1.844 17.688)",
    fill: "#1c2120"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_52",
    "data-name": "Group 52",
    transform: "translate(154.78 180.667)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_51",
    "data-name": "Group 51"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_50",
    "data-name": "Group 50",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M3.047-17.687V-7.671h-1.2V-17.687Zm0,0",
    transform: "translate(-1.844 17.688)",
    fill: "#1c2120"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_55",
    "data-name": "Group 55",
    transform: "translate(158.074 182.631)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_54",
    "data-name": "Group 54",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_53",
    "data-name": "Group 53",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M3.047-11.511v5.344h-1.2v-5.344ZM2.038-13.546a.612.612,0,0,1,.221-.478.744.744,0,0,1,.5-.195.718.718,0,0,1,.5.195.625.625,0,0,1,.212.478.619.619,0,0,1-.212.478.708.708,0,0,1-.5.195.733.733,0,0,1-.5-.195A.606.606,0,0,1,2.038-13.546Zm0,0",
    transform: "translate(-1.844 14.219)",
    fill: "#1c2120"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_58",
    "data-name": "Group 58",
    transform: "translate(160.907 185.118)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_57",
    "data-name": "Group 57",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_56",
    "data-name": "Group 56",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M7.137-9.607v5.38a2.465,2.465,0,0,1-.372,1.336,2.587,2.587,0,0,1-1.071.938A3.522,3.522,0,0,1,4.075-1.6a3.339,3.339,0,0,1-1.407-.274,5.069,5.069,0,0,1-1.177-.8L2.208-3.5a3.467,3.467,0,0,0,.867.628,2.217,2.217,0,0,0,.973.212,2.037,2.037,0,0,0,1.38-.425,1.484,1.484,0,0,0,.5-1.15l.018-1.009a2.215,2.215,0,0,1-.876.814,2.849,2.849,0,0,1-1.327.3A2.575,2.575,0,0,1,2.385-4.5a2.829,2.829,0,0,1-.991-1.026,2.853,2.853,0,0,1-.363-1.433,2.868,2.868,0,0,1,.38-1.469A2.754,2.754,0,0,1,2.438-9.456a2.716,2.716,0,0,1,1.38-.372,2.963,2.963,0,0,1,1.265.274,2.009,2.009,0,0,1,.867.69l.088-.743ZM4.093-5.13A1.946,1.946,0,0,0,5.278-5.5a1.756,1.756,0,0,0,.664-.982V-7.545a1.778,1.778,0,0,0-.69-.938,1.98,1.98,0,0,0-1.159-.354,1.806,1.806,0,0,0-1.318.522,1.744,1.744,0,0,0-.531,1.31,1.894,1.894,0,0,0,.239.947,1.89,1.89,0,0,0,.672.681A1.847,1.847,0,0,0,4.093-5.13Zm0,0",
    transform: "translate(-1.031 9.828)",
    fill: "#1c2120"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61",
    "data-name": "Group 61",
    transform: "translate(168.645 185.118)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60",
    "data-name": "Group 60",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_59",
    "data-name": "Group 59",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M4-5.165a2.165,2.165,0,0,0,1.3-.469l.557.894a3.767,3.767,0,0,1-.929.451,3.132,3.132,0,0,1-.956.159A3.178,3.178,0,0,1,2.412-4.5,2.61,2.61,0,0,1,1.385-5.519a2.972,2.972,0,0,1-.354-1.46,2.714,2.714,0,0,1,.389-1.433A2.889,2.889,0,0,1,2.5-9.448,3.077,3.077,0,0,1,4-9.828a2.559,2.559,0,0,1,1.743.611A3.134,3.134,0,0,1,6.712-7.5L2.474-6.023a1.736,1.736,0,0,0,.628.637A1.819,1.819,0,0,0,4-5.165Zm-.1-3.707a1.572,1.572,0,0,0-1.212.522,1.847,1.847,0,0,0-.478,1.31c0,.131,0,.23.009.3L5.34-7.89A1.764,1.764,0,0,0,4.792-8.6,1.412,1.412,0,0,0,3.907-8.873Zm0,0",
    transform: "translate(-1.031 9.828)",
    fill: "#1c2120"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_64",
    "data-name": "Group 64",
    transform: "translate(175.822 185.127)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63",
    "data-name": "Group 63"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_62",
    "data-name": "Group 62",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M5.162-9.812A1.754,1.754,0,0,1,6.4-9.361a1.536,1.536,0,0,1,.513,1.15v3.955H5.693V-7.8A1.083,1.083,0,0,0,5.418-8.5a.968.968,0,0,0-.734-.274,1.467,1.467,0,0,0-1.177.566,2.227,2.227,0,0,0-.46,1.451v2.5h-1.2V-9.6H2.932l.08,1.026a2.089,2.089,0,0,1,.849-.9A2.5,2.5,0,0,1,5.162-9.812Zm0,0",
    transform: "translate(-1.844 9.813)",
    fill: "#1c2120"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_67",
    "data-name": "Group 67",
    transform: "translate(182.505 185.189)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_66",
    "data-name": "Group 66",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_65",
    "data-name": "Group 65",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M5.836-4.713a2.657,2.657,0,0,1-.858.469,3.2,3.2,0,0,1-1.018.168,3.267,3.267,0,0,1-1.531-.345,2.568,2.568,0,0,1-1.035-.991A2.96,2.96,0,0,1,1.031-6.9a2.785,2.785,0,0,1,.38-1.46,2.651,2.651,0,0,1,1.035-.991,2.873,2.873,0,0,1,1.4-.354,3.043,3.043,0,0,1,2.026.672l-.6.788a2.922,2.922,0,0,0-.6-.319A1.866,1.866,0,0,0,3.951-8.7a1.671,1.671,0,0,0-.876.239,1.729,1.729,0,0,0-.619.655,1.806,1.806,0,0,0-.23.911,1.812,1.812,0,0,0,.239.92,1.864,1.864,0,0,0,.655.664,1.864,1.864,0,0,0,.947.239,1.8,1.8,0,0,0,1.15-.389Zm0,0",
    transform: "translate(-1.031 9.703)",
    fill: "#1c2120"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_70",
    "data-name": "Group 70",
    transform: "translate(188.395 185.118)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_69",
    "data-name": "Group 69",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_68",
    "data-name": "Group 68",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M4-5.165a2.165,2.165,0,0,0,1.3-.469l.557.894a3.767,3.767,0,0,1-.929.451,3.132,3.132,0,0,1-.956.159A3.178,3.178,0,0,1,2.412-4.5,2.61,2.61,0,0,1,1.385-5.519a2.972,2.972,0,0,1-.354-1.46,2.714,2.714,0,0,1,.389-1.433A2.889,2.889,0,0,1,2.5-9.448,3.077,3.077,0,0,1,4-9.828a2.559,2.559,0,0,1,1.743.611A3.134,3.134,0,0,1,6.712-7.5L2.474-6.023a1.736,1.736,0,0,0,.628.637A1.819,1.819,0,0,0,4-5.165Zm-.1-3.707a1.572,1.572,0,0,0-1.212.522,1.847,1.847,0,0,0-.478,1.31c0,.131,0,.23.009.3L5.34-7.89A1.764,1.764,0,0,0,4.792-8.6,1.412,1.412,0,0,0,3.907-8.873Zm0,0",
    transform: "translate(-1.031 9.828)",
    fill: "#1c2120"
  }))))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSkubiq);
export default __webpack_public_path__ + "static/media/logo_skubiq.226a559117a1252c4f871b86314813bf.svg";
export { ForwardRef as ReactComponent };